new Swiper('.home-swiper', {
  slidesPerView: 1.22,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // Tablet portrait: 1.22 slides would make the aspect-ratio images taller than the viewport
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3.875,
      spaceBetween: 20,
    },
  },
});

document.querySelectorAll('.home-alternative-swiper').forEach((el) => {
  // At 1920px three 467px slides fill the view, so a group of 3 pages a full set
  const slidesPerGroup = el instanceof HTMLElement && el.dataset.fullSetNav === 'true' ? 3 : 1;

  new Swiper(el, {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1600: {
        slidesPerView: 'auto',
        spaceBetween: 137,
        slidesPerGroup,
      },
    },
  });
});

const productArchiveEl = document.querySelector('.product-archive');
const productArchiveThumbsEl = document.querySelector('.product-archive-thumbs');

if (productArchiveEl) {
  // Thumbs are optional (section setting), so the main slider must not depend on them
  const productArchiveThumbs = productArchiveThumbsEl
    ? new Swiper(productArchiveThumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: true,
        breakpoints: {
          1024: {
            spaceBetween: 30,
          },
        },
      })
    : null;

  // The thumbs module only tracks one slide, so the framed set of visible slides is synced by hand
  const syncProductArchiveThumbs = (/** @type {any} */ archive) => {
    if (!productArchiveThumbs) return;
    const thumbs = productArchiveThumbs.slides;
    const setSize = Math.ceil(archive.params.slidesPerView);
    const setStart = Math.max(0, Math.min(archive.activeIndex, thumbs.length - setSize));
    const setEnd = setStart + setSize - 1;

    thumbs.forEach((/** @type {Element} */ thumb, /** @type {number} */ index) => {
      const isActive = index >= setStart && index <= setEnd;
      thumb.classList.toggle('is-active', isActive);
      thumb.classList.toggle('is-set-start', index === setStart);
      thumb.classList.toggle('is-set-end', index === setEnd);
      if (isActive) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });

    productArchiveThumbs.slideTo(setStart);
  };

  // Portrait iPad Pro (up to 1100px wide) keeps the tablet slider, matching the CSS tablet tier
  const productArchiveDesktop = window.matchMedia(
    '(min-width: 1101px), (min-width: 1024px) and (orientation: landscape)'
  );
  const productArchiveEvents = {
    init: syncProductArchiveThumbs,
    slideChange: syncProductArchiveThumbs,
  };
  /** @type {any} */
  let productArchive;

  // cssMode can't be switched through breakpoints, so the slider is rebuilt when crossing 1024px
  const initProductArchive = () => {
    productArchive?.destroy(true, true);
    productArchive = productArchiveDesktop.matches
      ? new Swiper(productArchiveEl, {
          slidesPerView: 3,
          slidesPerGroup: 3,
          // A share of the width, not px, so the slides stay image-wide and the outer images reach both arrows
          spaceBetween: '10.25%',
          navigation: {
            nextEl: productArchiveEl.parentElement?.querySelector('.swiper-button-next'),
            prevEl: productArchiveEl.parentElement?.querySelector('.swiper-button-prev'),
          },
          on: productArchiveEvents,
        })
      : new Swiper(productArchiveEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          // Native scrolling without snap, so a swipe carries momentum like scrolling the page
          cssMode: true,
          freeMode: true,
          // Tablet shows two smaller images, as desktop shows three, instead of one oversized image
          breakpoints: {
            750: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 40,
            },
          },
          on: productArchiveEvents,
        });
  };

  initProductArchive();
  productArchiveDesktop.addEventListener('change', initProductArchive);

  productArchiveThumbs?.slides.forEach((/** @type {Element} */ thumb, /** @type {number} */ index) => {
    thumb.addEventListener('click', () => {
      // Swiper blocks clicks that end a drag
      if (!productArchiveThumbs.allowClick) return;
      // Snap to a set boundary so thumbs land on the same sets the arrows page through
      const group = productArchive.params.slidesPerGroup;
      productArchive.slideTo(Math.floor(index / group) * group);
    });
  });
}

if(window.innerWidth >= 1024) {
new Swiper('.stories-swiper', {
  slidesPerView: 1.22,
  spaceBetween: 10,
  navigation: {
    nextEl: '.stories-swiper-button-next',
    prevEl: '.stories-swiper-button-prev',
  },
  breakpoints: {
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1600: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    },
  },
});
}

const bannerSwiper = new Swiper('.banner-slider-container', {
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 800,
  // A video on the last slide advances with slideNext(), which is a no-op at the end without rewind
  rewind: true,
  autoplay: {
    delay: 5000,
  },
  on: {
    init: function (/** @type {any} */ swiper) {
      // video_tag always renders autoplay, so hidden slides would otherwise play in the background.
      // Removing autoplay matters on Safari: a plain pause can be overridden once the video is ready,
      // which made the next slide fade in mid-clip and then jump back when it became active.
      swiper.slides.forEach((/** @type {Element} */ slide, /** @type {number} */ index) => {
        slide.querySelectorAll('[data-banner-video] video').forEach((video) => {
          if (!(video instanceof HTMLVideoElement)) return;
          video.autoplay = false;
          video.removeAttribute('autoplay');
          if (index === swiper.activeIndex) return;
          video.pause();
          video.currentTime = 0;
        });
      });
      assignDirections();
      handleVideoSlide(swiper);
    },
    slideChangeTransitionStart: function (/** @type {any} */ swiper) {
      const prevSlide = swiper.slides[swiper.previousIndex];
      if (prevSlide) {
        prevSlide.classList.add('is-leaving');
        const prevVideo = prevSlide.querySelector('[data-banner-video] video');
        // Rewinding here would flash the first frame during the fade-out; transitionEnd rewinds it
        if (prevVideo) prevVideo.pause();
      }

      // The incoming slide starts fading in now, so rewind its video before it is visible.
      // Doing this at transitionEnd instead caused the video to fade in mid-clip and then jump back.
      const activeVideo = swiper.slides[swiper.activeIndex]?.querySelector('[data-banner-video] video');
      if (activeVideo instanceof HTMLVideoElement) {
        activeVideo.pause();
        activeVideo.currentTime = 0;
      }
    },
    transitionEnd: function (/** @type {any} */ swiper) {
      swiper.slides.forEach((/** @type {Element} */ slide, /** @type {number} */ index) => {
        slide.classList.remove('is-leaving');
        if (index === swiper.activeIndex) return;
        const video = slide.querySelector('[data-banner-video] video');
        if (video instanceof HTMLVideoElement) {
          video.pause();
          video.currentTime = 0;
        }
      });
      resetAnimations();
      handleVideoSlide(swiper);
    },
  },
});

function handleVideoSlide(/** @type {any} */ swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  if (!activeSlide) return;

  const videoWrapper = activeSlide.querySelector('[data-banner-video]');

  if (videoWrapper) {
    swiper.autoplay.stop();

    const img = activeSlide.querySelector('.banner-slider-image');
    if (img) {
      img.style.animation = 'none';
    }

    const tryBindVideo = () => {
      const video = videoWrapper.querySelector('video');
      if (!video) return;
      if (video._bannerEndedHandler) {
        video.removeEventListener('ended', video._bannerEndedHandler);
      }

      video._bannerEndedHandler = function () {
        swiper.slideNext();
        swiper.autoplay.start();
      };

      video.addEventListener('ended', video._bannerEndedHandler);
      const isMuted = videoWrapper.dataset.muted !== 'false';
      video.muted = isMuted;
      video.currentTime = 0;
      video.play().catch(() => {
        setTimeout(() => {
          swiper.slideNext();
          swiper.autoplay.start();
        }, 2000);
      });
    };

    const video = videoWrapper.querySelector('video');
    if (video) {
      tryBindVideo();
    } else {
      const observer = new MutationObserver(() => {
        if (videoWrapper.querySelector('video')) {
          observer.disconnect();
          tryBindVideo();
        }
      });
      observer.observe(videoWrapper, { childList: true, subtree: true });
      setTimeout(() => { observer.disconnect(); }, 3000);
    }
  } else {
    if (!swiper.autoplay.running) {
      swiper.autoplay.start();
    }
  }
}


function assignDirections() {
  const slides = document.querySelectorAll('.banner-slider-container .swiper-slide');
  let autoIndex = 0;
  slides.forEach((/** @type {Element} */ slide) => {
    if (slide.querySelector('[data-banner-video]')) return;

    const img = slide.querySelector('.banner-slider-image');
    if (!img) return;

    img.classList.remove('direction-up', 'direction-down', 'direction-left', 'direction-right');

    const directionEl = /** @type {HTMLElement|null} */ (slide.querySelector('[data-direction]'));
    const direction = directionEl?.dataset.direction || 'auto';

    if (direction !== 'auto') {
      img.classList.add('direction-' + direction);
    } else {
      // Cycle through the 4 directions automatically
      const dirs = ['up', 'right', 'down', 'left'];
      img.classList.add('direction-' + dirs[autoIndex % 4]);
      autoIndex++;
    }
  });
}

function resetAnimations() {
  const allImages = document.querySelectorAll('.banner-slider-image');
  allImages.forEach((img) => {
    if (img instanceof HTMLElement) {
      const slide = img.closest('.swiper-slide');
      if (slide && !slide.classList.contains('swiper-slide-active')) {
        img.style.animation = 'none';
        void img.offsetHeight;
        img.style.animation = '';
      }
    }
  });
}

new Swiper('.technical-details-swiper-mobile', {
  slidesPerView: 1.5,
  spaceBetween: 12,
  grabCursor: true,
});

// Slide widths come from CSS (200px, 250px from 1440px)
document.querySelectorAll('.technical-details-swiper-desktop').forEach((el) => {
  // Arrows live in the header next to the title, outside the slider
  const nav = el.closest('.technical-details')?.querySelector('.technical-details__nav');

  new Swiper(el, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    grabCursor: true,
    navigation: {
      nextEl: nav?.querySelector('.swiper-button-next'),
      prevEl: nav?.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      1440: {
        spaceBetween: 24,
      },
    },
  });
});

